import { moduleRegistry } from './module-registry';
import { CutsheetsV2Module } from 'features/cutsheets/v2';
import { CapabilitiesV1Module } from 'features/capabilities/v1';
import { ReportingModule } from 'features/reporting/module';
import { ChatModule } from 'pages/processor/chat/module';
import { NotificationsModule } from 'pages/processor/notifications/module';
import { ExportsModule } from 'pages/processor/exports/module';
import { IntegrationsModule } from 'pages/integrations/module';
import { InvoicesModule } from 'pages/invoices/module';

/**
 * Initialize and register all application modules
 * This should be called once at application startup
 */
export function initializeModules(): void {
  console.log('[Modules] Initializing application modules...');

  // Register all feature modules here
  moduleRegistry.register(CutsheetsV2Module);
  moduleRegistry.register(CapabilitiesV1Module);
  moduleRegistry.register(ReportingModule);
  moduleRegistry.register(ChatModule);
  moduleRegistry.register(NotificationsModule);
  moduleRegistry.register(ExportsModule);
  moduleRegistry.register(IntegrationsModule);
  moduleRegistry.register(InvoicesModule);

  console.log(
    `[Modules] Initialized ${moduleRegistry.getAll().length} modules`,
  );
}
